<div class="flex items-center gap-sm {{ extraClass }}" (click)="changed.emit(!value)">
  <input
    type="checkbox"
    class="pointer-events-none form-checkbox rounded-xs text-info border-gray-300 focus:outline-none focus:ring-transparent focus:shadow-none {{
      extraCheckboxClass
    }}"
    style="box-shadow: none !important"
    [ngStyle]="{ width: size + 'px', height: size + 'px' }"
    [checked]="value"
    [indeterminate]="indeterminate"
    [disabled]="disabled"
  />
  @if (label) {
    <div
      class="text-sm leading-sm text-txt cursor-pointer {{ extraLabelClass }}"
      [ngClass]="{ 'text-txt-disabled!': disabled }"
    >
      @if (!mobileLabel) {
        <span>{{ label }}</span>
      } @else {
        <span class="hidden md:block">{{ label }}</span>
        <span class="md:hidden">{{ mobileLabel }}</span>
      }
    </div>
  }
</div>
